import { useStore, type Rect, type XYPosition } from '@xyflow/react';
import { useMemo } from 'react';

import { ReadableViewportHelper } from './readable-viewport-helper';

interface UseChartOverflowParams {
  nodes: ReadonlyArray<{ position: XYPosition }>;
  nodeSize: { width: number; height: number };
  contentBounds?: Rect;
}

function useChartOverflow({
  nodes,
  nodeSize,
  contentBounds,
}: Readonly<UseChartOverflowParams>) {
  const zoom = useStore((s) => s.transform[2]);
  const canvasWidth = useStore((s) => s.width);
  const canvasHeight = useStore((s) => s.height);
  const bounds = useMemo(() => {
    if (nodes.length === 0) return null;
    return (
      contentBounds ??
      ReadableViewportHelper.getBounds(
        nodes.map((n) => n.position),
        nodeSize
      )
    );
  }, [nodes, nodeSize, contentBounds]);

  if (!bounds || canvasWidth === 0 || canvasHeight === 0) return false;
  return ReadableViewportHelper.isOverflowing(
    bounds,
    { width: canvasWidth, height: canvasHeight },
    zoom
  );
}

export { useChartOverflow };
